module.exports = __webpack_public_path__ + "img/1.c96bc34d.png";